export const TOUCH_PICKER_QUERY = '(pointer: coarse) and (hover: none)';
export const TOUCH_PICKER_SEARCH_THRESHOLD = 10;

export function countPickerOptions(options, groupChildren = null) {
  if (!Array.isArray(options)) return 0;
  if (!groupChildren) return options.length;

  return options.reduce((count, group) => {
    const children =
      typeof groupChildren === 'function'
        ? groupChildren(group)
        : String(groupChildren)
            .split('.')
            .reduce((value, key) => value?.[key], group);
    return count + (Array.isArray(children) ? children.length : 0);
  }, 0);
}

// The threshold applies only to complete option catalogs. Remote
// pickers use the same device policy but always keep search available.
export const touchPickerPolicyMixin = {
  data() {
    return {
      touchPickerMedia: null,
      touchPickerDevice:
        typeof window !== 'undefined' && Boolean(window.matchMedia?.(TOUCH_PICKER_QUERY).matches),
      touchPickerSessionOpen: false,
      touchPickerSearchLatched: false,
    };
  },
  mounted() {
    this.touchPickerMedia = window.matchMedia?.(TOUCH_PICKER_QUERY) || null;
    this.syncTouchPickerDevice();
    this.touchPickerMedia?.addEventListener('change', this.syncTouchPickerDevice);
  },
  beforeUnmount() {
    this.touchPickerMedia?.removeEventListener('change', this.syncTouchPickerDevice);
  },
  computed: {
    isTouchPickerContext() {
      const brand =
        this.$page?.props?.uiBrand ??
        (typeof document !== 'undefined' ? document.documentElement.dataset.uiBrand : null);
      return brand === 'bayhive' && this.touchPickerDevice;
    },
    useTouchPicker() {
      return this.isTouchPickerContext && !this.remote;
    },
    touchPickerFilter() {
      return (
        this.touchPickerOptionCount > TOUCH_PICKER_SEARCH_THRESHOLD || this.touchPickerSearchLatched
      );
    },
  },
  watch: {
    touchPickerOptionCount(count) {
      if (this.touchPickerSessionOpen && count > TOUCH_PICKER_SEARCH_THRESHOLD) {
        this.touchPickerSearchLatched = true;
      }
    },
  },
  methods: {
    syncTouchPickerDevice() {
      this.touchPickerDevice = Boolean(this.touchPickerMedia?.matches);
    },
    beginTouchPickerSession() {
      this.touchPickerSessionOpen = true;
      this.touchPickerSearchLatched = this.touchPickerOptionCount > TOUCH_PICKER_SEARCH_THRESHOLD;
    },
    endTouchPickerSession() {
      this.touchPickerSessionOpen = false;
      this.touchPickerSearchLatched = false;
    },
  },
};
